import ActionTypes from 'app/login/ActionTypes';
import reducer from 'app/login/reducer';
import routes from 'app/login/routes';

export default {
  reducers: {
    login: reducer,
  },
  actionTypes: ActionTypes,
  routes,
};
